module.exports = __webpack_public_path__ + "media/images/hero_images/index-800-709c71c969980a64221e68454cdc1f57.jpg";